export default __webpack_public_path__ + "static/media/ev-wall-socket.b0c8e300.jpg";